import { type HTMLMotionProps } from 'framer-motion';

import { type ContractRewardType } from '@/common/types/contract';

const config: Record<
  ContractRewardType,
  {
    motionProps: Partial<Omit<HTMLMotionProps<'div'>, 'children'>>;
    description: string;
    classNames?: {
      title?: string | undefined;
      description?: string | undefined;
      wrapper?: string | undefined;
    };
  }
> = {
  cash: {
    motionProps: {
      layoutId: 'cash-reward',
      initial: { transition: { duration: 0 } },
      transition: { duration: 0.5, ease: 'easeOut' },
      onLayoutAnimationComplete: () => {
        console.log('layout animation complete');
      },
    },
    description: 'Cash',
    classNames: {
      title: '!text-[1.25rem]',
      description: '!text-xs',
    },
  },
  point: {
    motionProps: {
      layoutId: 'point-reward',
      transition: { duration: 0.5, ease: 'easeOut' },
    },
    description: 'Star Points',
    classNames: {
      title: 'first:!text-[1.25rem]',
      description: '!text-xs',
    },
  },
  dice: {
    motionProps: {
      layoutId: 'dice-reward',
      transition: { duration: 0.5, ease: 'easeOut' },
    },
    description: 'Dices',
    classNames: {
      title: '!text-[1.25rem]',
      description: '!text-xs',
    },
  },
  silverTicket: {
    motionProps: {
      layoutId: 'silver-ticket-reward',
      transition: { duration: 0.5, ease: 'easeOut' },
    },
    description: 'Silver Ticket',
    classNames: {
      title: '!text-[1.25rem]',
      description: '!text-xs',
    },
  },
  goldTicket: {
    motionProps: {
      layoutId: 'silver-ticket-reward',
      transition: { duration: 0.5, ease: 'easeOut' },
    },
    description: 'Gold Ticket',
    classNames: {
      title: '!text-[1.25rem]',
      description: '!text-xs',
    },
  },
  diamondTicket: {
    motionProps: {
      layoutId: 'silver-ticket-reward',
      transition: { duration: 0.5, ease: 'easeOut' },
    },
    description: 'Diamond Ticket',
    classNames: {
      title: '!text-[1.25rem]',
      description: '!text-xs',
    },
  },
};

export { config };
